import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify';

import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import { useLocation } from 'react-router-dom';

import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table
} from "reactstrap";
import { number } from 'prop-types';
const API_URL = process.env.REACT_APP_API_BASE_URL;


const AddCityMaster = (props) => {

  const navigate = useNavigate();
  const location = useLocation();
  const [stateList, setStateList] = useState([]);
  const productImageRef = useRef(null)

  let initial = {
    staff_name: '',
    staff_email: '',
    staff_mobile: '',
    staff_dob: null,
    staff_aadhar: '',
    staff_profile: '',
    staff_role: '',
    staff_address: '',
    staff_joining_date: null,
    staff_department: '',
    staff_salary: null,
    staff_status: 'active',
    staff_shift: '',
    staff_emergency_contact: '',
    staff_gender: '',
    staff_marital_status: '',
    staff_experience: '',
    staff_bank_details: '',
    branch_master_id: null
  }
  const [cityDetail, setCityDetail] = useState({});
  const [editMode, setEditMode] = useState(false)
  const [branchMasterTable, setBranchMasterTable] = useState([]);
  const [stateTable, setStateTable] = useState([]);


  const onHandleBack = () => {
    navigate(-1)
  }

  const onCancel = () => {
    if (props && typeof props.onCancel === 'function') {
      props.onCancel()
    }
  }
  
  const onHandleInputChange = (e) => {

    const { name, value, type, files } = e.target;

    if (name == "state_id") {

      let findArray = stateTable.find(data => data.state_Id == value);
      setCityDetail(prevState => ({
        ...prevState,
        [name]: value,
        "state_name": findArray?.state_Name
      }));
    } else {
      setCityDetail(prevState => ({
        ...prevState,
        [name]: value
      }));
    }



  };


  const handleSubmit = async () => {
    try {

      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      console.log(cityDetail, "cityDetailcityDetail")


      const response = await apiService.post(`/api/CityMaster/create`, cityDetail, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);

        if (props && typeof props.onInsert === 'function') {
          props?.onInsert()
        } else {
          navigate("/city")
        }
        // setCityDetail(initial)
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  }

  const getCityDetail = async (cityId) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/CityMaster/citybyid?cityId=${cityId}`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setCityDetail(response.city_MasterDetailByID)
        // setPreviewImage(API_URL + response.staffMasterByID?.staff_profile)
        // if (response.staffMasterByID) {
        setEditMode(true)
        // }
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const UpdateStaffDetail = async () => {

    try {

      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.put(`/api/CityMaster/update?cityId=${cityDetail.id}`, cityDetail, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        alert(response.message)
        // navigate("/staff")
        // setPortfolioData(initial)
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }

  }

  const getState = async () => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/HelperMaster/allState`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setStateTable(response.state_Master)
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  }


  console.log(stateTable)


  useEffect(() => {
    getState();
  }, [])

  useEffect(() => {

    if (props && typeof props.onCancel === 'function') {
      return
    }

    if (location.state) {
      getCityDetail(location.state.cityId)
      setEditMode(true)
    }
  }, [location.state]);


  return (
    <Row>
      <Col>
        <Card className='bg-white pd-10 card-box mb-30'>
          <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">


            {editMode ?

              <div className="d-flex align-items-center">
                <i className="bi bi-bell mr-2"></i>
                Edit City Detail
              </div>
              :
              <div className="d-flex align-items-center">
                <i className="bi bi-bell mr-2"></i>
                Add City Detail
              </div>
            }

            {props && typeof props.onCancel === 'function' ?
              <Button color="danger" size="bg" onClick={onCancel} className="ml-auto">
                Cancel
              </Button>
              :
              <Button color="warning" size="bg" onClick={onHandleBack} className="ml-auto">
                Back
              </Button>
            }


          </CardTitle>
          <CardBody>
            <Form>
              <Row>
                <Col>
                  <FormGroup>
                    <Label for="state_id">State Name</Label>
                    <Input 
                      type="select"  className="custom-select"
                      name="state_id"
                      id="state_id"
                      value={cityDetail.state_id}
                      onChange={onHandleInputChange}
                    >
                      <option value="">Select</option>
                      {stateTable.map((option) => (
                        <option key={option.state_Id} value={option.state_Id}>
                          {option.state_Name}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
                <Col>
                  <FormGroup>
                    <Label for="city_Name">City Name</Label>
                    <Input 
                      type="text"
                      name="city_Name"
                      id="city_Name"
                      value={cityDetail.city_Name}
                      onChange={onHandleInputChange}
                    />
                  </FormGroup>
                </Col>
              </Row>


              <Col xl={8}>
                {
                  editMode ?
                    <Button style={{ backgroundColor: '#007bff', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }}
                      onClick={UpdateStaffDetail}>
                      Update
                    </Button>
                    :
                    <Button style={{ backgroundColor: '#007bff', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }}
                      onClick={handleSubmit}>
                      Save
                    </Button>
                }

              </Col>
            </Form>

          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AddCityMaster;
